import Navigation from "./lib/navigation";
import stickyContent from "./lib/stickyContent";
import Accordion from "./lib/accordion";
import Splide from "@splidejs/splide";
import SmoothScroll from "smooth-scroll";
import { modalKitInit, modalKitShow, modalKitHide } from "./lib/modal-kit.js";

/* -------------------------------------------------------------------
  utility
------------------------------------------------------------------- */
const smoothScroll = new SmoothScroll('a[href*="#"]', {
  speed: 500,
  speedAsDuration: true,
  popstate: true,
  updateURL: false,
  offset: (anchor, toggle) => {
    if (toggle.href == "#") {
      return 0;
    } else {
      const headerHeight = document.querySelector(".js-header")
        ? document.querySelector(".js-header").offsetHeight * 1.5
        : 0;
      return headerHeight;
    }
  },
});

Navigation("header-nav__btn", "body");

stickyContent("footer", "header");

const footerNavItem = new Accordion(".js-footer-nav-item", {
  speed: 400,
  target: "next",
  event: "click",
  breakpoint: 599,
  breakpointType: "max",
  disableLink: true,
});

const spAccordion = new Accordion(".js-sp-accordion", {
  speed: 400,
  target: "next",
  event: "click",
  breakpoint: 768,
  breakpointType: "max",
  disableLink: true,
});

document.addEventListener("DOMContentLoaded", () => {
  const interViewSplideOptions = {
    type: "slide",
    arrows: false,
    pagination: false,
    gap: "20px",
    fixedWidth: 290,
    trimSpace: true,
    mediaQuery: "min",
    breakpoints: {
      1440: { destroy: true },
    },
  };
  const interviewListClass = ".js-interview-list";
  const interviewList = document.querySelector(interviewListClass);
  if (!interviewList) return;
  const interviewListType = interviewList.dataset.type;

  if (interviewListType === "aside") {
    interViewSplideOptions.fixedWidth = 247;
    interViewSplideOptions.breakpoints[768] = {
      fixedWidth: 290,
    };
  }

  const interViewSplide = new Splide(
    interviewListClass,
    interViewSplideOptions
  );

  interViewSplide.mount();
  const prev = document.querySelector(".js-interview-arrow-prev");
  const next = document.querySelector(".js-interview-arrow-next");

  prev.addEventListener("click", () => interViewSplide.go("<"));
  next.addEventListener("click", () => interViewSplide.go(">"));

  // 非loop時の無効化表示（任意）
  const update = () => {
    const Controller = interViewSplide.Components.Controller;
    prev.disabled = interViewSplide.index <= 0;
    next.disabled = interViewSplide.index >= Controller.getEnd();
  };
  interViewSplide.on("mounted move updated", update);
});

modalKitInit({ defaultTarget: "#recruitModal" });
